import React, { useEffect, useState } from "react";
import FormDropZone from "../../../../library/dropZone/FormDropZone";
import {
  ORG_ID,
  PAGE_SIZE,
  ROW_PER_PAGE_SIZE,
} from "../../../../constant/constant";
import GridTable from "../../../../library/custom/gridTable/GridTable";
import { TableLoader } from "../../../../library/common/Loader";
import NORow from "../../../../library/custom/noRow/noRow";
import { Grid } from "@mui/material";
import {
  convertUTCtoLocalTimeZone,
  InactiveClient,
} from "../../../../utils/helper";
import ReportRowManipulte from "../../../incidents/incidentList/ReportRowManipulte";
import { useNavigate, useLocation } from "react-router-dom";
import { SETUP_ADD_CREDENTIAL } from "../../../../constant/routeContant";
import { getPreviousRoute } from "../../../../utils/routeTracker";

const AddScormFile = ({ scormUploadCoursesList, getScormUploadCourses }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const [pageSize, setPageSize] = useState(() => {
    const previousRoute = getPreviousRoute();
    const shouldPreserve =
      previousRoute &&
      previousRoute.startsWith(SETUP_ADD_CREDENTIAL) &&
      sessionStorage.getItem("scormFileListPreserveState") === "true";
    
    if (shouldPreserve) {
      const savedPageSize = sessionStorage.getItem("scormFileListPageSize");
      return savedPageSize ? parseInt(savedPageSize) : PAGE_SIZE;
    }
    return PAGE_SIZE;
  });
  
  const [page, setPage] = useState(() => {
    const previousRoute = getPreviousRoute();
    const shouldPreserve =
      previousRoute &&
      previousRoute.startsWith(SETUP_ADD_CREDENTIAL) &&
      sessionStorage.getItem("scormFileListPreserveState") === "true";
    
    if (shouldPreserve) {
      const savedPage = sessionStorage.getItem("scormFileListPage");
      return savedPage ? parseInt(savedPage) : 0;
    }
    return 0;
  });
  
  const [resourceFilesData, setResourceFilesData] = useState("");
  
  React.useEffect(() => {
    sessionStorage.removeItem("scormFileListPreserveState");
    sessionStorage.removeItem("scormFileListPage");
    sessionStorage.removeItem("scormFileListPageSize");
  }, []);

  const [formValue, setFormValue] = useState({
    fileUrls: "",
  });

  const handleFileChange = (files) => {
    setResourceFilesData(files);
  };

  const handleDeleteImageURL = () => {
    setFormValue({ fileUrls: "" });
  };

  useEffect(() => {
    getScormUploadCourses({
      page: page + 1,
      pageSize,
      orgId: parseInt(ORG_ID()),
    });
  }, [page, pageSize]);

  useEffect(() => {
    setFormValue((prev) => ({ ...prev, fileUrls: resourceFilesData }));

    if (resourceFilesData) {
      getScormUploadCourses({
        page: 1,
        pageSize,
        orgId: parseInt(ORG_ID()),
      });
      setPage(0);
    }
  }, [resourceFilesData]);

  const columns = [
    { field: "scormCourseId", headerName: "Scorm ID", width: 90 },
    { field: "courseId", headerName: "Course ID", width: 120 },
    { field: "title", headerName: "Title", flex: 1 },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      renderCell: (cellValues) => {
        const statusMap = {
          0: "New Upload",
          1: "Pending",
          2: "Completed",
          3: "Error",
        };

        return <>{statusMap[cellValues?.row?.status] || "NA"}</>;
      },
    },
    {
      field: "createdOn",
      headerName: "Created On",
      flex: 1,
      valueGetter: (params) =>
        params.row.createdOn
          ? convertUTCtoLocalTimeZone(params.row.createdOn)
          : "",
    },
    {
      field: "",
      width: 70,
      sortable: false,
      disableClickEventBubbling: true,
      renderCell: (rows) => {
        return (
          <ReportRowManipulte
            rows={rows}
            edit={rows?.row?.status === 2}
            editLabel="Edit Credential Type"
            editOnClick={() => handleEdit(rows)}
            addBtn={rows?.row?.status === 1}
            addBtnLabel="Add Credential Type"
            addForm={() => addCredentialForm(rows)}
          />
        );
      },
    },
  ];

  const rows = scormUploadCoursesList?.data?.scormFiles ?? [];

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPage(0);
  };

  const handlePagignation = (newPage) => {
    setPage(newPage);
  };
  const addCredentialForm = (rows) => {
    if (InactiveClient()) return;
    navigate(SETUP_ADD_CREDENTIAL, {
      state: {
        id: rows.row.id,
        editMode: false,
        isScormCredential: true,
        scormListData: rows?.row,
      },
    });
  };

  const handleEdit = (rows) => {
    if (InactiveClient()) return;
    sessionStorage.setItem("scormFileListPreserveState", "true");
    sessionStorage.setItem("scormFileListPage", page.toString());
    sessionStorage.setItem("scormFileListPageSize", pageSize.toString());
    navigate(SETUP_ADD_CREDENTIAL, {
      state: {
        id: rows.row.id,
        editMode: true,
        isScormCredential: true,
        scormListData: rows?.row,
        credentialNameId: rows?.row?.credentialNameId,
      },
    });
  };
  return (
    <div>
      <FormDropZone
        paraText1={"Drop the files here ..."}
        paraText2={"Drop the files here, "}
        paraText3={"or Browse"}
        handleFileChange={handleFileChange}
        fileType={4}
        imageUrl={formValue?.fileUrls}
        deleteImageURL={handleDeleteImageURL}
        id="addResources"
        key="addResources"
        isMuliple={true}
        isDoc={false}
        isImage={false}
        allFiles={false}
        isScorm={true}
      />

      <p className="fileTypeSupport">Supported file types: zip</p>
      <p className="errorMsg">
        All Marketplace training, including OSHA 10/30, is billed on a
        pay-per-use basis. Admin approval settings control access. Usage data is
        recorded and invoiced monthly.
      </p>

      <Grid mt={2}>
        <div className="table_style_ui">
          <GridTable
            getRowId={(row) => row?.scormCourseId}
            rows={rows}
            columns={columns}
            rowCount={scormUploadCoursesList?.data?.noOfRecords}
            checkboxSelection={false}
            pageSize={pageSize}
            rowsPerPageOptions={ROW_PER_PAGE_SIZE}
            onPageSizeChange={handlePageSizeChange}
            onPageChange={handlePagignation}
            paginationMode="server"
            page={page}
            disableSelectionOnClick
            components={{
              LoadingOverlay: TableLoader,
              NoRowsOverlay: NORow,
            }}
          />
        </div>
      </Grid>
    </div>
  );
};

export default AddScormFile;
